// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bxJN-","colBig":"styles_colBig__3UfpQ","colSmall":"styles_colSmall__2yrlm"};